import {NgModule} from '@angular/core';
import {LoginPageComponent} from './login-page/login-page.component';
import {SharedModule} from '../shared/shared.module';
import {PageNotFoundComponent} from './page-not-found/page-not-found.component';
import {TotpSetupComponent} from './totp-setup/totp-setup.component';


@NgModule({
  declarations: [LoginPageComponent,
  PageNotFoundComponent,
  TotpSetupComponent],
  imports: [
    SharedModule,



  ],
  exports: [
    LoginPageComponent,
    TotpSetupComponent,
  ]
})
export class AuthModule { }
